import useDesignTokens from '@/hooks/useDesignTokens';

const BOOTHS = [0, 1, 2, 3].flatMap(column => [0, 1].map(row => ({ x: 22 + column * 30, y: 20 + row * 34 })));

const PlanSketch = (props: { stroke: string; fill: string; }) => (
	<>
		<rect x="12" y="10" width="136" height="80" rx="3" fill={props.fill} stroke={props.stroke} strokeWidth="2" />
		{BOOTHS.map(booth => (
			<rect key={`${booth.x}-${booth.y}`} x={booth.x} y={booth.y} width="24" height="22" rx="2" fill="none" stroke={props.stroke} strokeWidth="1.5" />
		))}
	</>
);

export const RegionIllustration = () => {
	const tokens = useDesignTokens();

	return (
		<svg viewBox="0 0 200 110" width="100%" height="100%">
			<PlanSketch stroke={tokens.text.muted} fill={tokens.surface.card} />
			<rect x="156" y="62" width="34" height="28" rx="2" fill={tokens.surface.card} stroke={tokens.border.default} strokeWidth="1.5" />
			<path d="M161 70h24M161 76h18M161 82h21" stroke={tokens.border.default} strokeWidth="2" />
			<rect x="6" y="4" width="148" height="92" rx="5" fill={`color-mix(in srgb, ${tokens.color.primary} 8%, transparent)`} stroke={tokens.color.primary} strokeWidth="2.5" strokeDasharray="7 5" />
		</svg>
	);
};

export const ReviewIllustration = () => {
	const tokens = useDesignTokens();
	const doubtful = 5;

	return (
		<svg viewBox="0 0 200 110" width="100%" height="100%">
			<rect x="30" y="10" width="136" height="80" rx="3" fill={tokens.surface.card} stroke={tokens.text.muted} strokeWidth="2" />
			{BOOTHS.map((booth, index) => {
				const color = index === doubtful ? tokens.color.warning : tokens.color.primary;

				return (
					<g key={`${booth.x}-${booth.y}`}>
						<rect x={booth.x + 18} y={booth.y} width="24" height="22" rx="2" fill={`color-mix(in srgb, ${color} 30%, transparent)`} stroke={color} strokeWidth="1.5" />
						{index === doubtful && <text x={booth.x + 30} y={booth.y + 16} textAnchor="middle" fontSize="14" fontWeight="700" fill={color}>?</text>}
					</g>
				);
			})}
		</svg>
	);
};

export const PlacementIllustration = () => {
	const tokens = useDesignTokens();

	return (
		<svg viewBox="0 0 200 110" width="100%" height="100%">
			<rect width="200" height="110" fill={tokens.surface.subtle} />
			<path d="M-10 30L210 70M60 -10L40 120M150 -10L170 120" stroke={tokens.surface.card} strokeWidth="9" />
			<g transform="rotate(-12 100 55) translate(20 6)">
				{BOOTHS.map(booth => (
					<rect key={`${booth.x}-${booth.y}`} x={booth.x} y={booth.y} width="24" height="22" rx="2" fill={`color-mix(in srgb, ${tokens.color.primary} 45%, transparent)`} stroke={tokens.color.primary} strokeWidth="1.5" />
				))}
			</g>
		</svg>
	);
};
